<template>
  <div class="container">
    <van-pull-refresh v-model="isrefresh" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list && list.length > 0 ? '没有更多了' : ''"
        @load="onLoad"
        class="waterfall"
      >
        <ListProductItemView :isShow="true"
          v-for="(item, index) in list"
          :key="index"
          :item="item"
        />
      </van-list>
    </van-pull-refresh>
    <van-empty description="暂无商品记录" v-if="list && list.length == 0" />
  </div>
</template>

<script>
import ListProductItemView from '@/components/product/index.vue'
export default {
  name: 'ShopProductView',
  components: { ListProductItemView },
  data () {
    return {
      isrefresh: false,
      loading: false,
      finished: false,
      list: null,
      page: 1,
      limit: 10
    }
  },
  methods: {
    onRefresh () {
      this.list = null
      this.isrefresh = true
      this.finished = false
      this.page = 1
    },
    async onLoad () {
      await this.$http({
        method: 'post',
        url: 'getproduct',
        data: { page: this.page, limit: this.limit,shop_id:this.$route.query.id }
      })
        .then(res => {
          this.loading = false
          this.isrefresh = false
          if (!this.list) this.list = res.data.list
          else {
            this.list = this.list.concat(res.data.list)
          }
          if (this.list.length >= res.data.pagination.count) {
            this.finished = true
          } else {
            this.page += 1
          }
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
}

.waterfall {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
  grid-auto-flow: dense;
  padding: 10px;
}
</style>
